/* eslint-disable */
export default {
  copy: 'コピー',
} as const;

// @key: @#@"copy"@#@ @source: @#@"Copy"@#@
